<template>
  <div class="admin-manage">
    <AdminTable
      :admins="admins"
      :isLoading="isLoading.fetch"
      :paginationOptions="paginationOptions"
      @create="openCreateModal"
      @edit="openEditModal"
      @changeStatus="handleStatusChange"
      @onPagination="handlePagination"
    />

    <Modal :showModal="showFormModal" :title="formModalTitle" @closeModal="closeFormModal">
      <template #content>
        <AdminForm
          :admin="currentAdmin"
          :isLoading="isLoading.create || isLoading.update"
          :errorMessage="errorMessage"
          @submit="handleSubmit"
          @cancel="closeFormModal"
        />
      </template>
    </Modal>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import AdminTable from '../organisms/AdminTable.vue';
import AdminForm from '../organisms/AdminForm.vue';
import Modal from '@/components/Modal.vue';
import { useAdmins } from '../composables/useAdmins.js';

const {
  admins,
  isLoading,
  errorMessage,
  currentAdmin,
  pagination,
  fetchAdmins,
  addAdmin,
  editAdmin,
  toggleAdminStatus,
  setCurrentAdmin,
  clearCurrentAdmin,
  handlePagination
} = useAdmins();

const showFormModal = ref(false);
const isEditMode = ref(false);

const formModalTitle = computed(() => {
  return isEditMode.value ? 'Edit Administrator' : 'Create Administrator';
});

const paginationOptions = computed(() => ({
  limit: [10, 20, 50], 
  total: pagination.totalItems,
  current: pagination.currentPage,
  itemsPerPage: pagination.itemsPerPage
}));

const openCreateModal = () => {
  isEditMode.value = false;
  clearCurrentAdmin();
  showFormModal.value = true;
};

const openEditModal = (admin) => {
  isEditMode.value = true;
  setCurrentAdmin(admin);
  showFormModal.value = true;
};

const closeFormModal = () => {
  showFormModal.value = false;
  clearCurrentAdmin();
};

const handleSubmit = async (formData) => {
  let result;

  if (isEditMode.value) {
    result = await editAdmin({ ...currentAdmin.value, ...formData });
  } else {
    result = await addAdmin(formData);
  }

  if (result.success) {
    closeFormModal();
  }
};

const handleStatusChange = async (admin) => {
  await toggleAdminStatus(admin);
};

onMounted(() => {
  fetchAdmins();
});
</script>

<style scoped lang="scss">
.admin-manage {
  padding: 1.5rem;

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
}
</style>